/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@charset \"UTF-8\";.k-hierarchy-cell{width:40px!important}.k-hierarchy-cell .k-icon{width:100%;display:flex;align-items:center;justify-content:center}td.k-hierarchy-cell,th.k-hierarchy-cell{width:20px!important}.k-i-add:before,.k-i-plus:before,.k-plus:before{content:\"\uE014\"}.k-i-kpi-trend-equal:before,.k-i-minus:before,.k-minus:before{content:\"\uE015\"}"];
export { styles as styles };
